export async function getNodeHttpModules() {
  return {
    nodeHttpsTransport: undefined,
    nodeHttpTransport: undefined,
  }
}
